import React, { ReactNode } from 'react';
import '../../../styles/CarelonRx/footer.css';

interface FooterProps {
  children?: ReactNode;
}

const Footer: React.FC<FooterProps> = ({ children }) => {
  return (
    <footer className="crx-footer" id="footer">
      {children ? (
        children
      ) : (
        <>
          {/* Container 1: Links Section */}
          <div className="footer-section footer-section-1">
            <div className="footer-container">
              {/* Logo */}
              <div className="footer-logo">
                <img src="/assets/carelonRx/images/carelonRxWhiteLogo.png" alt="CarelonRx Logo" tabIndex={0} />
              </div>

              {/* Links Group - 3 Columns */}
              <div className="footer-links-wrapper">
                {/* Column 1 */}
                <div className="footer-link-column">
                  <a href="https://www.carelonrx.com/accessibility" target="_blank" rel="noopener noreferrer">Accessibility</a>
                  <a href="https://www.carelonrx.com/docs/CarelonRxMemberRights.pdf" target="_blank" rel="noopener noreferrer">Member rights and responsibilities</a>
                  <a href="https://www.carelonrx.com/report-fraud" target="_blank" rel="noopener noreferrer">Report fraud</a>
                </div>

                {/* Column 2 */}
                <div className="footer-link-column">
                  <a href="https://www.carelonrx.com/state-disclosures" target="_blank" rel="noopener noreferrer">State disclosures</a>
                  <a href="https://www.carelonrx.com/non-discrimination-notice" target="_blank" rel="noopener noreferrer">Non-discrimination notice</a>
                  <a href="https://developer.carelonrx.com/terms-and-conditions" target="_blank" rel="noopener noreferrer">Developer portal access agreement</a>
                </div>

                {/* Column 3 */}
                <div className="footer-link-column">
                  <a href="https://developer.carelonrx.com/" target="_blank" rel="noopener noreferrer">Digital products and APIs</a>
                  <a href="https://www.carelonrx.com/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of use</a>
                  <a href="https://www.carelonrx.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy policy</a>
                </div>
              </div>

              {/* Right Section - Social Icons + Download */}
              <div className="footer-right-section">
                <a href="https://www.linkedin.com/company/carelonrx" target="_blank" rel="noopener noreferrer" className="footer-icon-link">
                  <img src="/assets/carelonRx/images/Image (LinkedIn).png" alt="LinkedIn" />
                  <span>LinkedIn</span>
                </a>
                <a href="https://twitter.com/carelonrx" target="_blank" rel="noopener noreferrer" className="footer-icon-link">
                  <img src="/assets/carelonRx/images/Image(Twitter).png" alt="Twitter" />
                  <span>Twitter</span>
                </a>
                <a href="https://www.carelonrx.com/mobile-app" target="_blank" rel="noopener noreferrer" className="footer-icon-link">
                  <img src="/assets/carelonRx/images/Image(Download App ).png" alt="Download App" />
                  <span>Download the app</span>
                </a>
              </div>
            </div>
          </div>
          
          {/* Container 2: Legal Section */}
          <div className="footer-section footer-section-2">
            <div className="footer-container">
              <div className="footer-bottom">
                <p tabIndex={0}>
                  CarelonRx. All Rights Reserved. The CarelonRx name and CarelonRx logo are registered trademarks. Services provided by CarelonRx, Inc.
                </p>
                <p tabIndex={0}>
                  Attention: If you speak any language other than English, language assistance services, free of charge, are available to you. Call our Customer Service number, (TTY: 711).
                </p>
                <p tabIndex={0}>
                  ATENCIÓN: Si habla español, tiene a su disposición servicios gratuitos de asistencia lingüística. Llame a nuestro número de Servicio de Atención al Cliente (TTY: 711).
                </p>
                <p tabIndex={0}>
                  注意：如果您使用非英語的其他語言，您可以免費獲得語言援助服務。請致電聯絡客戶服務部（聽語障用戶請致電：711）。
                </p>
              </div>
            </div>
          </div>

          {/* Container 3: Badges/Accreditation Section */}
          <div className="footer-section footer-section-3">
            <a href="https://accreditnet.urac.org/directory/#/accreditation/PBM-22/info" target="_blank" rel="noopener noreferrer">
              <img src="/assets/carelonRx/images/Urac.png" alt="URAC Accredited" tabIndex={0} />
            </a>
            <a href="https://reportcards.ncqa.org/other-health-care-organization/Other_0012M00002B9ONAQA3" target="_blank" rel="noopener noreferrer">
              <img src="/assets/carelonRx/images/NCQA.png" alt="NCQA Accredited" tabIndex={0} />
            </a>
          </div>
        </>
      )}
    </footer>
  );
};

export default Footer;
